export class Notice {
  public id: number;
  public title: string;
  public date: string;
  public enable: boolean

  constructor(id: number, title: string, date: string, enable?: boolean) {
    this.id = id;
    this.title = title;
    this.date = date;
    this.enable = enable;
  }
}

export class NoticeFieldValidation {
  public id: number;
  public type: string;
  public question: string;

  populate(data: any): NoticeFieldValidation {
    this.id = data.id;
    this.type = data.type
    this.question = data.question
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/@core/models/notice.model.ts